/**
 * @sort id
 * @sort internal_code
 * @sort alias_name
 * @sort name
 */
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
        width: '5%',
    },
    {
        text: 'código interno',
        value: 'internal_code',
        sortable: true,
        width: '10%',
    },
    {
        text: 'alias',
        value: 'alias_name',
        sortable: true,
    },
    {
        text: 'nombre',
        value: 'name',
        sortable: true,
        width: '20%',
    },
    {
        text: 'stock sucursal',
        value: 'stock_total',
        align: 'right',
        format: 'number-point',
    },
    {
        text: 'stock critico',
        value: 'branch_offices_critical_stock',
        align: 'right',
        format: 'number-point',
    },
    {
        text: 'inventariable',
        value: 'wh_item_is_inventoriable',
        align: 'center',
        format: 'boolean',
    },
    {
        text: 'reenvasable',
        value: 'is_repackaged',
        align: 'center',
        format: 'boolean',
    },
]
